import React from 'react';
import { CommandLineIcon } from '@heroicons/react/24/outline';

const AdminLogs: React.FC = () => {
  return (
    <div className="max-w-7xl mx-auto">
      <header className="app-page-header hidden sm:block bg-white dark:bg-gray-800 border-b-[3px] border-lime-400 mb-6">
        <div className="p-4 md:py-6 md:px-8 flex justify-between items-center">
          <div className="flex items-center gap-3">
            <CommandLineIcon className="h-7 w-7 text-primary-600 dark:text-primary-400" />
            <div>
              <h1 className="text-[28px] font-bold text-gray-900 dark:text-white">Systemlogs</h1>
              <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">Systemprotokolle und Aktivitäten</p>
            </div>
          </div>
        </div>
      </header>
      <div className="card">
        <p className="text-gray-600 dark:text-gray-400">
          Systemlogs werden hier angezeigt.
        </p>
      </div>
    </div>
  );
};

export default AdminLogs;
